<footer>
    <div class="container">
        <div class="row">

            <div class="col-12 col-sm-12 col-md-9 col-lg-9">
                <div class="row">
                    <div class="col-6 col-sm-3 col-md-3 col-lg-3">
                        <div class="fotr-media-item">
                            <h3>Popular Searches</h3>
                            <ul class="list-unstyled fotr-menu">
                                <li><a href="#" [routerLink]="['/buy-properties-in-delhi']" 
                                        (click)="redirectToPropertyListing('Delhi')">Delhi</a></li>
                                <li><a a href="#" [routerLink]="['/buy-properties-in-mumbai']" 
                                        (click)="redirectToPropertyListing('Mumbai')">Mumbai</a></li>
                                <li><a a href="#" [routerLink]="['/buy-properties-in-hyderabad']" 
                                        (click)="redirectToPropertyListing('Hyderabad')">Hyderabad</a></li>
                                <li><a a href="#" [routerLink]="['/buy-properties-in-bengaluru']" 
                                        (click)="redirectToPropertyListing('Bengaluru')">Bengaluru</a></li>
                                <li><a a href="#" [routerLink]="['/buy-properties-in-chennai']"  (click)="redirectToPropertyListing('Chennai')">Chennai</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-6 col-sm-3 col-md-3 col-lg-3">
                        <div class="fotr-media-item">
                            <h3>Quick Links</h3>
                            <ul class="list-unstyled fotr-menu">
                                <li><a href="https://www.iiflhomeloans.com/" target="_blank"
                                        (click)="ctaClickEvent('Quick Links','Home Loans')">Home Loans</a></li>
                                <li>
                                    <a href="https://www.iiflhomeloans.com/home-loan-emi-calculator" target="_blank"
                                        (click)="ctaClickEvent('Quick Links','EMI Calculator')">
                                        EMI Calculator</a>
                                </li>
                                <li>
                                    <a href="https://customerportal.iifl.com/home-loan-eligibility/?utm_source=WebsiteHFL&utm_subsource=ProductsHL_Exp"
                                        target="_blank" (click)="ctaClickEvent('Quick Links','Home Loan Eligibility')">
                                        Home Loan Eligibility</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-6 col-sm-3 col-md-3 col-lg-3">
                        <div class="fotr-media-item">
                            <h3>Knowledge Hub</h3>
                            <ul class="list-unstyled fotr-menu">
                                <li><a href="javascript:void(0)" (click)="scrollUp('Glossary','glossary')"
                                        routerLink="/glossary">Glossary</a></li>
                                <!-- <li><a href="javascript:void(0)" (click)="scrollUp('Knowledge Hub','News')"
                                        routerLink="/blog/list" [queryParams]="{selectedBlogCat:'news'}">News</a></li>
                                <li><a href="javascript:void(0)" (click)="scrollUp('Knowledge Hub','Blogs')"
                                        routerLink="/blog/list" [queryParams]="{selectedBlogCat:'blogs'}">Blogs</a></li> -->
                                         <li><a href="javascript:void(0)" (click)="scrollUp('Knowledge Hub','News')"
                                        routerLink="/blog/news">News</a></li>
                                <li><a href="javascript:void(0)" (click)="scrollUp('Knowledge Hub','Blogs')"
                                        routerLink="/blog/list">Blogs</a></li>
                                <!-- <li><a href="javascript:void(0)" (click)="scrollUp('Knowledge Hub','City Updates')"
                                        routerLink="/blog/list" [queryParams]="{selectedBlogCat:'city update'}">City Updates
                                        </a></li> -->
                                <li><a href="javascript:void(0)" (click)="scrollUp('Knowledge Hub','FAQs')"
                                        routerLink="/faq">FAQs</a></li>
                                        <li>
                                          <a href="javascript:void(0)" (click)="scrollUp('home-buying-guide','home-buying-guide')" routerLink="/home-buying-guide">Home Buying Guide</a>
                                        </li>
                                        
                            </ul>
                        </div>
                    </div>

                    <div class="col-6 col-sm-3 col-md-3 col-lg-3">
                        <div class="fotr-media-item">
                            <h3>Company</h3>
                            <ul class="list-unstyled fotr-menu">
                                <li><a href="javascript:void(0)" (click)="scrollUp('Company','About Us')"
                                        routerLink="/about-us">About Us</a></li>
                                <li><a href="javascript:void(0)" (click)="scrollUp('Company','Contact')"
                                        routerLink="/contact-us">Contact</a></li>
                                <li><a href="javascript:void(0)" (click)="scrollUp('Company','Privacy Policy')"
                                        routerLink="/privacy-policy">Privacy Policy</a></li>
                                <li><a href="javascript:void(0)" (click)="scrollUp('Company','Terms & Conditions')"
                                        routerLink="/terms-conditions">Terms & Conditions</a>
                                </li>
                                <li><a href="javascript:void(0)" (click)="scrollUp('Company','Disclaimer')"
                                        routerLink="/disclaimer">Disclaimer</a></li>
                            </ul>
                        </div>
                    </div>

                </div>
            </div>
            <div class="col-12 col-sm-12 col-md-3 col-lg-3">
                <div class="fotr-media-item fotr-abt-cnt">
                    <h3>Contact Us</h3>
                    <!-- <p><a href="#">+91 12345 67890</a></p> -->
                    <div class="row">
                        <div class="col-6 col-sm-6 col-md-12 col-lg-12">
                            <p><a href="mailto:{{info?.email}}">{{info?.email}}</a></p>
                            <p><a id="tollNum" href="tel:1800-2672-499">1800-2672-499</a></p>
                          
                        </div>
                     
                    </div>


                </div>
            </div>
        </div>
    </div>
    <section class="cpyrgt-wrap">
        <div class="container">
            <div class="row text-center">
                <div class="col-sm-12 col-md-12">
                    <p>© Copyright <b>All Rights Reserved. IIFL One Home 2025.</b> </p>
                </div>
            </div>
        </div>
    </section>
    <!-- <section class="cpyrgt-wrap">
        <div class="container">
            <div class="row text-center">
                <div class="col-sm-12 col-md-12">
                    <p>© Copyright <b>IIFL</b> 2023, All rights reserved.-->
    <!-- <a href="https://www.b2cinfosolutions.com/" target="_blank"> B2C Info Solutions</a> -->
    <!--</p>
                </div>
            </div>
        </div>
    </section>-->

</footer>